import { Box, CircularProgress, type BoxProps } from "@mui/material";

interface LoadingBoxProps extends BoxProps {
  padding?: number | string;
  minHeight?: number | string;
}

export function LoadingBox({
  padding = 6,
  minHeight,
  ...rest
}: LoadingBoxProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: padding,
        ...(minHeight !== undefined ? { minHeight } : {}),
      }}
      {...rest}
    >
      <CircularProgress />
    </Box>
  );
}
